import type { ClubFull } from "@/lib/types";
import { useToast } from "@/components/feature/ToastProvider";

interface ClubAccountSectionProps {
  club: ClubFull | null;
}

export default function ClubAccountSection({ club }: ClubAccountSectionProps) {
  const { toast } = useToast();
  const bank = club?.bank;

  // 계좌번호가 없으면 카드 자체를 숨김
  if (!bank?.account) return null;

  const accountText = [bank.name, bank.account].filter(Boolean).join(" ");

  const copyAccount = () => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(accountText)
        .then(() => toast("계좌번호를 복사했습니다.", "success"))
        .catch(() => toast("복사에 실패했습니다.", "error"));
    } else {
      toast("복사를 지원하지 않는 환경입니다.", "error");
    }
  };

  return (
    <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-16">
      <div className="mx-auto max-w-3xl">
        <div className="rounded-xl border border-secondary-200 bg-secondary-50 p-6 md:p-8">
          <div className="flex items-center gap-2 text-secondary-900">
            <i className="ri-bank-card-line text-xl" aria-hidden="true"></i>
            <h3 className="font-heading text-lg font-bold">클럽 계좌</h3>
          </div>
          <p className="mt-4 font-heading text-lg font-bold text-foreground-950">
            {accountText}
          </p>
          {bank.holder && (
            <p className="mt-1 text-sm text-foreground-600">예금주 {bank.holder}</p>
          )}
          <button
            type="button"
            onClick={copyAccount}
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-primary-950 hover:bg-secondary-600 transition-colors"
          >
            <i className="ri-file-copy-line" aria-hidden="true"></i>
            계좌번호 복사
          </button>
        </div>
      </div>
    </section>
  );
}